import React from 'react';
import { Box, Page } from '@wix/design-system';
import {
  useEssentials,
  useJunkYard,
  useRouterContext,
  useSiteContext,
  AppMarketPage,
  useComponentLoadReporter,
  homePageId,
  usePageLoad,
  getPageViewBiData,
} from '@wix/app-market-core';
import { appMarketPageView } from '@wix/bi-logger-app-market-data/v2';
import { HomePageHeader } from './home-page-header';
import s from '../pages.scss';
import { SaleBanner, WixCapitalDealerBanner } from '../../components';
import { HomePageSections } from './home-page-sections';

export function HomePage() {
  const reportLoadFinish = useComponentLoadReporter({
    componentId: homePageId,
  });
  const page = AppMarketPage.HOMEPAGE;
  const { route } = useRouterContext();
  const { routerData } = useJunkYard();
  const { biLogger, experiments } = useEssentials();
  const { horizontalNav } = useSiteContext();

  usePageLoad({
    route,
    oldRoute: routerData.route,
    onLoad: () =>
      biLogger.report(
        appMarketPageView(
          getPageViewBiData({
            routerData,
            pageType: page,
            pageName: page,
          }),
        ),
      ),
  });

  return (
    <Page
      className={`${s.appMarketPage} ${s.appMarketPageBackgroundColor}`}
      dataHook={homePageId}
    >
      <Page.Content>
        <WixCapitalDealerBanner />
        {experiments.enabled('specs.app-market.Sale') ? (
          <Box direction="vertical" marginBottom="30px" marginTop="40px">
            <SaleBanner layout="narrow" />
          </Box>
        ) : null}
        {!horizontalNav && <HomePageHeader />}
        <HomePageSections onLoad={reportLoadFinish} />
      </Page.Content>
    </Page>
  );
}
